"use strict";
/*
 * Created on 09.05.2019
 */

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PromoSettingsValidatorSets_1 = require("../PromoSettingsValidatorSets");
/**
 * Replenishment settings model
 * @author Tomáš Leity
 *
 * @param thresholdActivated
 * @param thresholdReplenishmentNotification
 */


var ReplenishmentSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReplenishmentSettings, _DomainObject_1$Domai);

  function ReplenishmentSettings(thresholdActivated, thresholdReplenishmentNotification, thresholdReplenishmentNotificationRel) {
    var _this;

    _classCallCheck(this, ReplenishmentSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReplenishmentSettings).call(this));
    _this.thresholdActivated = thresholdActivated;
    _this.thresholdReplenishmentNotification = thresholdReplenishmentNotification;
    _this.thresholdReplenishmentNotificationRel = thresholdReplenishmentNotificationRel;
    return _this;
  }

  return ReplenishmentSettings;
}(DomainObject_1.DomainObject);

exports.ReplenishmentSettings = ReplenishmentSettings;

ReplenishmentSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ReplenishmentSettings.name);
  return {
    thresholdActivated: builder.bool('thresholdActivated'),
    thresholdReplenishmentNotification: builder.num.apply(builder, ['thresholdReplenishmentNotification'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators))),
    thresholdReplenishmentNotificationRel: builder.num.apply(builder, ['thresholdReplenishmentNotificationRel'].concat(_toConsumableArray(PromoSettingsValidatorSets_1.PromoSettingsValidatorSets.getNumberValidators)))
  };
}();